import "./packages-modal.scss";

import classNames from "classnames";
import { observer } from "mobx-react-lite";
import { useState } from "react";

import SvgIcon from "@client/components/reusable/SvgIcons";
import { ReactComponent as ListIcon } from "@client/components/reusable/SvgIcons/library/list_icon.svg";
import { useRootContext } from "@client/context/RootContext";

interface PackagesModalProps {
	orderId: number;
	rejectedProducts: string[];
	closeOrderCardModal?: () => any;
}

const title = "נא לציין בכמה אריזות השתמשת עבור הזמנה זו";

export const PackagesModal = observer(
	({ orderId, rejectedProducts, closeOrderCardModal }: PackagesModalProps) => {
		const {
			modalStore,
			vendorStore: {
				orderOperations: { readyForDelivery },
			},
		} = useRootContext();

		const [selectedItem, setSelectedItem] = useState(0);

		function onPackageItemClick(e: any, item: number) {
			e.preventDefault();
			e.stopPropagation();
			setSelectedItem(item);
		}

		function handleOnSubmit() {
			readyForDelivery?.(orderId, rejectedProducts, selectedItem);
			modalStore.removeModal("packages-modal");
			closeOrderCardModal && closeOrderCardModal();
		}

		const packages = [1, 2, 3, 4, 5];
		return (
			<div className="packages-container">
				<SvgIcon
					component={ListIcon}
					width="48"
					height="48"
					className="list-icon"
				/>
				<div className="packages-modal-title">{title}</div>
				{!!packages?.length && (
					<div className="package-items-container">
						{packages.map((packageItem) => (
							<div
								key={packageItem}
								className={classNames("package-item", {
									["is-active"]: packageItem === selectedItem,
								})}
								onClick={(e) => onPackageItemClick(e, packageItem)}
							>
								{packageItem}
							</div>
						))}
					</div>
				)}
				<button
					className={classNames("packages-modal-submit-btn", {
						["is-active"]: selectedItem,
					})}
					disabled={!selectedItem}
					onClick={handleOnSubmit}
				>
					Submit
				</button>
			</div>
		);
	}
);
